import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ApiContractService } from './api-call-providers/api-contract.service';
import { LoadingController, Events } from 'ionic-angular';
import { DataCacheService } from './data-cache.service';
import { EVENTS_CONFIG } from './../configs/events.config';
import { PAGES_CONFIG } from './../configs/pages.config';
import { COOKIES_CONFIG } from './../configs/cookies.config';

export class Contract {

  contractId: string = '';
  name: string = '';

  constructor(data) {
    this.contractId = data.contractId;
    this.name = data.name;
  }
}

@Injectable()
export class ContractService {

  // - システム名 ex) ケアデータコネクト , バイタリー など
  systemName: string = 'ケアデータコネクト';
  
  // - 法人ID
  contractGroupId: string;
  // - 法人名
  contractGroupName: string;

  // - ログイン時に取得する情報
  private contractsSource = new Subject<any>();
  contracts = this.contractsSource.asObservable();

  // - 契約詳細
  private contractInfoSource = new Subject<Contract[]>();
  contractInfo = this.contractInfoSource.asObservable();

  // - 契約更新
  private postContractInfoSource = new Subject<Contract[]>();
  postContract = this.postContractInfoSource.asObservable();

  // - 契約自動更新
  private postChangeContractInfoSource = new Subject<Contract[]>();
  postChangeContract = this.postChangeContractInfoSource.asObservable();

  // - 支払い履歴
  private getContractInfoSource = new Subject<Contract[]>();
  getContractInfo = this.getContractInfoSource.asObservable();

  constructor(
    private events: Events,
    private _dataCacheService: DataCacheService,
    private apiContractService: ApiContractService,
    public loadingCtlr: LoadingController
  ) {
    // ライセンスキー変更イベントを検知する
    this.events.subscribe(EVENTS_CONFIG.AUTH_LICENSE_KEY, (data) => {

      // 契約情報をStorageにいれる
      this._dataCacheService.set(COOKIES_CONFIG.CONTRACTS_DATA, data, data.expired)
      this._dataCacheService.set(COOKIES_CONFIG.CDC_CONTRACT, data, data.expired).then(() => {
        // 法人情報および事業所のリストを更新する
        Promise.all([
          this.setContract(),
          this.setSystemName(),
        ]).then(() => {
          // セット完了後、ログインページに遷移
          this.events.publish(EVENTS_CONFIG.SET_ROOT, PAGES_CONFIG.LOGIN)
        })

      })
    });

    this.setContract()
    this.setSystemName()
  }

  /**
   * データの初期化
   */
  async load() {
    this.apiContractService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.CDC_CONTRACT)
    this.apiContractService.isLoading = false
    return this.contractsSource.next(_data);
  }

  async setContract() {

    let _body = await this._dataCacheService.get(COOKIES_CONFIG.CDC_CONTRACT)
    if (!_body.isExist()) {
      return
    }
    let body = _body.data;;

    this.contractGroupId = body.contractGroupId;
    this.contractGroupName = body.contractGroupName;
    if (!body.contracts) {
      return false;
    }
    // 念の為初期化
    // let contracts = []
    // this.contractsSource.next([])
    // body.contracts.forEach(_contract => {
    //   contracts.push(new Contract(_contract));
    // });
    this.contractsSource.next(body)

  }

  async setSystemName() {
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.CDC_CONTRACT);
    if (_data.isExist()) {
      this.systemName = _data.data["systemName"]
    }
  }

  /**
   * データの初期化
   */
  async loadContractInfo() {
    this.apiContractService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.CONTRACT_DATA)
    if (!_data.isExist()) {
      await this.fetchContractInfo();
      return
    }
    this.apiContractService.isLoading = false
    return this.contractInfoSource.next(_data.data);
  }

  /**
   * APIで契約情報を取得する
   */
  async fetchContractInfo() {
    let res: any = await this.apiContractService.get()
    if (res.expired) {
      await this._dataCacheService.set(COOKIES_CONFIG.CONTRACT_DATA, res, res.expired)
    }
    this.contractInfoSource.next(res)
    return this.apiContractService.get();
  }

  /**
   * APIで有料プランを申し込む
   * 
   */
  async postRequestContractPlan(params) {
    let loading = this.loadingCtlr.create({
      content: '申し込み中...'
    });
    loading.present();
    let res = await this.apiContractService.applyPlan(params)
    this.postContractInfoSource.next(res)
    loading.dismiss();
  }

  /**
   * 自動更新の設定を変更するAPI
   */
  async postChangeAutoContractRenewal(params){
    let loading = this.loadingCtlr.create({
      content: '申し込み中...'
    });
    loading.present();
    let res = await this.apiContractService.changeAutoContractRenewal(params)
    this.postChangeContractInfoSource.next(res)
    loading.dismiss();
  }

  /**
   * 支払履歴/申し込み履歴取得API
   */
  async getContractPaymentHistory() {
    let loading = this.loadingCtlr.create({
      content: '取得中...'
    });
    loading.present();
    let res = await this.apiContractService.paymentHistory()
    this.getContractInfoSource.next(res)
    loading.dismiss();
  }
  

}



// WEBPACK FOOTER //
// ./src/providers/contract.service.ts